import { createContext } from "react";

const CustomCursorContext = createContext();

export default CustomCursorContext;